/**
 * @ngdoc filter
 * @memberOf filters.mask
 */
function mask() {
  return (email = '') => {
    let mask = 'xxx';
    return email.replace(/(.)(.*?)(.)(@.*)/g, (full, one, two, three, four) => {
      return one.toUpperCase() + mask + three.toUpperCase() + four;
    });
  }
}

export default angular.module('filters.mask', [])
  .filter('mask', mask)
  .name;



// WEBPACK FOOTER //
// ./src/client/app/filters/mask.filter.js